import { OfferGridModel } from './offerGridModel';

export class OfferListModel {
    public offers: Array<OfferGridModel>;
    public count: number;
    public notSentCount: number;
}